import { Location } from 'history';
import * as React from 'react';
import { match, Redirect, Route, Switch } from 'react-router';

import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { FlowSpaceProvider } from './FlowSpaceProvider';

interface FlowRouteParams {
  readonly id: string;
}

interface FlowRouteProps {
  readonly match: match<FlowRouteParams>;
  readonly location: Location;
}

export interface FlowSpaceProps extends ReactDirectiveProps {
  readonly previousUrl: string;
  readonly urls: SpacesSiteUrls;
}

export const FlowSpaceRouter: React.FunctionComponent<FlowSpaceProps> = (props) => {
  const flowSpaceProviderFor = (subplace: string): (routeProps: FlowRouteProps) => JSX.Element => {
    return (routeProps: FlowRouteProps) => {
      const flowId = routeProps.match.params.id;
      const showPublishResult = props.previousUrl.includes(props.urls.flowPublishresultUrl(flowId));
      return <FlowSpaceProvider
        angularContext={props.angularContext}
        flowId={flowId}
        siteUrls={props.urls}
        subplaceName={subplace}
        routeLocationSearch={routeProps.location.search}
        routeLocationPath={routeProps.location.pathname}
        showPublishResult={showPublishResult}
      />;
    };
  };

  return (
    <Switch>
      <Route exact path={props.urls.flowPublishresultPath(':id')} render={(routeProps: FlowRouteProps) =>
        <Redirect to={props.urls.flowOverviewPath(routeProps.match.params.id)}/>
      }/>
      <Route exact path={props.urls.flowPath(':id')} render={(routeProps: FlowRouteProps) =>
        <Redirect to={props.urls.flowOverviewPath(routeProps.match.params.id)}/>
      }/>
      <Route exact path={props.urls.flowOverviewPath(':id')} render={flowSpaceProviderFor('overview')}/>
      <Route exact path={props.urls.flowConnectionsPath(':id')} render={flowSpaceProviderFor('connections')}/>
      <Route exact path={props.urls.flowScheduledTasksPath(':id')} render={flowSpaceProviderFor('scheduledTasks')}/>
      <Route exact path={props.urls.flowRunHistoryPath(':id')} render={flowSpaceProviderFor('runHistory')}/>
      <Route path={props.urls.flowLineagePath(':id')} render={flowSpaceProviderFor('lineage')}/>
      <Route render={() => <RouterError errorType={'default'} urls={props.urls}/>}/>
    </Switch>
  );
};
